<template>
  <div class="home">
    <!------------------- header start ----------------->
    <div class="header">
      <div class="left">
        <div class="logo">
          <img src="https://epc.yiec.com/uploads/logo.png">
        </div>
        <!-- <div class="logo2">
          <img src="https://epc.yiec.com/uploads/yiec_logo.png">
        </div> -->
      </div>
      <div class="middle">
        <div class="search">

          <el-form class="searchForm" :model="itemSearchForm">
            <el-form-item>
              <el-input size="small" v-model="itemSearchForm.pn" placeholder="PN"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="itemSearchForm.name" size="small" clearable filterable placeholder="Name">
                <el-option v-for="item in nameList" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item>
              <el-input size="small"  v-model="itemSearchForm.name" placeholder="Part Name"></el-input>
            </el-form-item> -->
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" :disabled="userLevel == 1"
                @click="searchItem">
                search</el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-refresh" @click="reset">reset</el-button>
            </el-form-item> -->
          </el-form>

        </div>
      </div>
      <div class="right">
        <div class="quick-menus">
          <a href="https://www.facebook.com/well.guo.5" target="_blank" class="quick-menu">
            <img src="../../assets/img/face.png" />
          </a>
          <a href="https://twitter.com/GuoWell?s=09" target="_blank" class="quick-menu">
            <img src="../../assets/img/twitter.png" />
          </a>
          <a href="https://www.instagram.com/guowell?r=nametag" target="_blank" class="quick-menu">
            <img src="../../assets/img/ins.png" />
          </a>
        </div>
        <div class="cart">
          <el-tooltip class="item" effect="dark" content="My Cart" placement="bottom">
            <el-badge :value="cartCount" class="item">
              <span @click="getCartList"><i style="font-size:22px;" class="el-icon-shopping-cart-2"></i></span>
            </el-badge>

          </el-tooltip>
        </div>
        <div class="person">
          <span @click="toggle"><i style="font-size:22px;" class="el-icon-user-solid"></i></span>
          <div style="z-index:2000;" v-if="personShow" class="menus">
            <div class="el-icon-tickets person-menu" @click="myOrders">&nbsp;&nbsp;My Orders</div>
            <div class="el-icon-chat-dot-round person-menu" @click="leaveMessage">&nbsp;&nbsp;Leave message</div>
            <div class="el-icon-chat-square person-menu" @click="showChangePwdDialog">&nbsp;&nbsp;Edit Pwd</div>
            <div class="el-icon-switch-button person-menu" @click="logout">&nbsp;&nbsp;Logout</div>
          </div>
        </div>

      </div>
    </div>
    <!------------------- header end ----------------->

    <!------------------- body start ----------------->
    <div class="content" ref="content">
      <div class="left-box">
        <ctree :treeData='treeLevelList' ref='ctree' @clickNode='clickNode' :checkBox='false'></ctree>
      </div>
      <div class="resize" title="收缩侧边栏">
        ⋮
      </div>
      <div class="right-box">
        <!------------ 0.空白背景 start--------->
        <div v-if="currentContentPanel == 'bgContent'" class="bg-content">
          <div class="entry-navs">
            <div class="nav-menu">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item><a href="http://www.yiec.com" target="_blank">Home</a></el-breadcrumb-item>
                <el-breadcrumb-item>
                  <!-- TODO -->
                  <a style="cursor:pointer;" href="https://epc.yiec.com/saic-admin/home">EPC Home</a>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="nav-title">
            <span>Brand</span>
          </div>
          <div class="entrys">
            <div class="menus">
              <div class="mg" @click="clickMg()"><img width="100%" src="https://epc.yiec.com/uploads/munu_mg.png"></div>
              <div class="maxus" @click="clickMauxs()"><img width="100%"
                  src="https://epc.yiec.com/uploads/munu_mauxs.png"></div>
              <div class="wulin" @click="clickWuling()"><img width="100%"
                  src="https://epc.yiec.com/uploads/munu_wuling.png"></div>

              <div class="wulin" @click="clickIVECO()"><img width="100%" src="https://epc.yiec.com/uploads/IVECO.png">
              </div>
              <div class="wulin" @click="clickChery()"><img width="100%" src="https://epc.yiec.com/uploads/chery.jpg">
              </div>
              <div class="wulin" @click="clickROEWE()"><img width="100%" src="https://epc.yiec.com/uploads/ROEWE.png">
              </div>
              <div class="JETOUR" @click="clickJETOUR()"><img width="100%" src="https://epc.yiec.com/uploads/bt.png">
              </div>
            </div>

          </div>

          <div class="nav-title">
            <span>Item Name Category</span>
            <span class="more" @click="itemNameMore">MORE></span>
          </div>
          <div class="itemNameMenus">
            <div @click="searchByItemName(item.name)" class="item-name" v-for="item in nameList.slice(0, 12)"
              :key="item.id">
              <div class="cover">
                <img :src="item.image" />
              </div>
              <div class="title">{{ item.name }}</div>
            </div>
          </div>

          <div class="nav-title">
            <span>Videos</span>
            <span class="more" @click="videoMore">MORE></span>
          </div>

          <!-- <Video id="myVideo" class="myVideo" controls  preload="auto" poster="aa">
            <source src="ss" type="video/mp4">
          </Video> -->

          <div class="itemNameMenus">
            <!-- <div class="item-name" v-for="item in videoList" :key="item.id">
              <Video class="cover" controls preload="auto" :poster="item.image">
                <source :src="item.videoUrl" type="video/mp4">
              </Video>
              <div style="line-height:34px;" class="title">{{ item.name }}</div>
            </div> -->
            <div @click="openVideo(item.videoUrl)" class="item-name" v-for="item in videoList" :key="item.id">
              <div class="cover">
                <img :src="item.image" />
              </div>
              <div class="title">{{ item.name }}</div>
            </div>

          </div>
        </div>
        <!------------ 1.子栏目列表 start--------->
        <div v-if="currentContentPanel == 'trees'" class="trees-panel">
          <div v-if="treeNavs && treeNavs.length > 0" class="tree-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item><a href="http://www.yiec.com" target="_blank">Home</a></el-breadcrumb-item>
              <el-breadcrumb-item>
                <!-- TODO -->
                <a href="https://epc.yiec.com/saic-admin/home" target="_blank">EPC Home</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item v-for="(item, index) in treeNavs" :key="index"><span @click="clickNode(item)">{{
                item.name
              }}</span></el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="tree-childs">
            <el-tooltip v-for="(item, index) in treeChildList" :key="index" effect="light" :content="item.name"
              placement="bottom">
              <div @click="clickNode(item)" class="tree-item">
                <div class="item-image"><img :src="item.image"></div>
                <div class="item-title">{{ item.name }}</div>
              </div>
            </el-tooltip>
          </div>
        </div>
        <!------------ 1.子栏目列表 end--------->

        <!------------ 2.子栏目详情+配件列表 start--------->
        <div v-if="currentContentPanel == 'treeDetail'" class="treeDetail-panel">
          <div v-if="treeNavs && treeNavs.length > 0" class="tree-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item><a href="http://www.yiec.com" target="_blank">Home</a></el-breadcrumb-item>
              <el-breadcrumb-item v-for="(item, index) in treeNavs" :key="index"><span @click="clickNode(item)">{{
                item.name
              }}</span></el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <div class="treeDetail-box">
            <div class="treeDetail">
              <div class="tree-image">
                <!-- <img @click="onTreePreview" :src="currentNode.image"> -->
                <el-image style="width: 100%;height: 100%;object-fit: contain;" :src="currentNode.image"
                  :preview-src-list="[currentNode.image]">
                </el-image>
              </div>
              <!-- <el-image-viewer v-if="showTreeViewer" :on-close="closeTreeViewer" :url-list="[currentNode.image]" /> -->
            </div>
            <div class="item-list">
              <el-table stripe size="medium" :data="itemList" highlight-current-row border element-loading-text="拼命加载中"
                style="width: 100%;">
                <el-table-column prop="sort" label="Grade" align="center" min-width="40"></el-table-column>
                <el-table-column prop="pn" label="PN" align="center" min-width="70"></el-table-column>
                <el-table-column prop="name" label="Part Name" min-width="100"></el-table-column>
                <el-table-column prop="replacePn" label="Replace PN" min-width="60"></el-table-column>
                <el-table-column align="center" label="Operation" min-width="120">
                  <template slot-scope="scope">
                    <el-button size="mini" type="success" plain @click="showItemDetail(scope.row)">Detail</el-button>
                    <el-button size="mini" type="primary" plain @click="openCart(scope.row)">Add Cart</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!------------ 2.子栏目详情+配件列表 end--------->
        <!------------ 3.配件搜索列表 start--------->
        <div v-if="currentContentPanel == 'searchItems'" class="search-panel">
          <div class="nav-menu">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item><a href="http://www.yiec.com" target="_blank">Home</a></el-breadcrumb-item>
              <el-breadcrumb-item>
                <!-- TODO -->
                <a style="cursor:pointer;" href="https://epc.yiec.com/saic-admin/home">EPC Home</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <a href="#">Search Result</a>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-table stripe size="medium" :data="itemSearchList" highlight-current-row border
            element-loading-text="拼命加载中" style="width: 100%;">

            <el-table-column align="center" label="Car" prop="carName" min-width="120">
              <template slot-scope="scope">
                <a @click="clickSearchNode(scope.row.treeCar)" href="#" style="text-decoration:none">{{
                  scope.row.carName
                }}</a>
              </template>
            </el-table-column>

            <el-table-column label="Category" prop="treeName" min-width="140">
              <template slot-scope="scope">
                <a @click="clickSearchNode(scope.row.treeId)" href="#" style="text-decoration:none">{{
                  scope.row.treeName
                }}</a>
              </template>
            </el-table-column>

            <el-table-column prop="pn" label="PN" align="center" min-width="80"></el-table-column>
            <el-table-column prop="name" label="Part Name" min-width="90"></el-table-column>
            <el-table-column prop="replacePn" label="Replace PN" min-width="60"></el-table-column>
            <el-table-column align="center" label="Operation" min-width="100">
              <template slot-scope="scope">
                <el-button size="mini" type="success" plain @click="showItemDetail(scope.row)">Detail</el-button>
                <el-button size="mini" type="primary" plain @click="openCart(scope.row)">Add Cart</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!------------ 3.配件搜索列表 end--------->
        <!-------------4. order list start --------------->
        <div v-if="currentContentPanel == 'myorders'" class="search-panel">
          <div class="nav-menu">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item><a href="http://www.yiec.com" target="_blank">Home</a></el-breadcrumb-item>
              <el-breadcrumb-item>
                <!-- TODO -->
                <a style="cursor:pointer;" href="https://epc.yiec.com/saic-admin/home">EPC Home</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <a href="#">Order Result</a>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-table size="medium" :data="orderList" highlight-current-row border element-loading-text="拼命加载中"
            style="width: 100%;">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="orderNum" label="OrderNo" min-width="100"></el-table-column>
            <el-table-column label="CreateTime" align="center" min-width="130">
              <template slot-scope="scope">
                <div>{{ scope.row.createDate | timestampToTime }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="Title" min-width="180"></el-table-column>
            <el-table-column label="State" align="center" min-width="60">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state == 1" type="mini" size="warning" plain>Todo
                </el-button>
                <el-button v-if="scope.row.state == 2" type="mini" size="primary" plain>handing
                </el-button>
                <el-button v-if="scope.row.state == 3" type="mini" size="success" plain>complete
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Operation" align="center" min-width="130">
              <template slot-scope="scope">
                <el-button @click="cancelOrder(scope.row.id)" type="mini" size="danger" :disabled="scope.row.state != 1"
                  plain>Cancel</el-button>
                <el-button @click="orderDetail(scope.row.id)" type="mini" size="primary" plain>Detail</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <!------------4. order list end------------>
        <!------------5. 视频播放页面 start---------->
        <div class="video-play" v-show="videoPlayDialog">
          <span class="el-icon-close video-close" @click="closeVideo"></span>
          <video ref="videoRef" controls preload="auto" muted autoplay type="video/mp4">
          </video>
        </div>
        <!------------5. 视频播放页面 en ----------->
        <!------------6. 产品名称 和 视频 start ----------->
        <div style="padding-top:20px" class="nav-menu" v-if="currentContentPanel == 'itemNames'">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a href="http://www.yiec.com" target="_blank">Home</a></el-breadcrumb-item>
            <el-breadcrumb-item>
              <!-- TODO -->
              <a style="cursor:pointer;" href="https://epc.yiec.com/saic-admin/home">EPC Home</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <a href="#">Item Name Result</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="itemNameMenus" v-if="currentContentPanel == 'itemNames'">
          <div @click="searchByItemName(item.name)" class="item-name" v-for="item in nameList" :key="item.id">
            <div class="cover">
              <img :src="item.image" />
            </div>
            <div class="title">{{ item.name }}</div>
          </div>
        </div>

        <div style="padding-top:20px;" class="nav-menu" v-if="currentContentPanel == 'videos'">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a href="http://www.yiec.com" target="_blank">Home</a></el-breadcrumb-item>
            <el-breadcrumb-item>
              <!-- TODO -->
              <a style="cursor:pointer;" href="https://epc.yiec.com/saic-admin/home">EPC Home</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <a href="#">Video Result</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="itemNameMenus" v-if="currentContentPanel == 'videos'">
          <div @click="openVideo(item.videoUrl)" class="item-name" v-for="item in videoList" :key="item.id">
            <div class="cover">
              <img :src="item.image" />
            </div>
            <div class="title">{{ item.name }}</div>
          </div>
        </div>
        <!------------6. 产品名称 和 视频 end ----------->

      </div>
    </div>
    <!------------------- body end ----------------->

    <!------------------- foot start ----------------->
    <div class="footer">
      <div class="foot-left">

      </div>
      <div class="foot-right">
        <span>Email:{{ footData.email }}</span>
        <span>Mobile:{{ footData.mobile }}</span>
        <span></span>
      </div>
    </div>
    <!------------------- foot end ----------------->

    <!------------------- item-detail start ----------------->
    <el-dialog style="padding-bottom:20px;" top="5vh" title="Part Detail" :visible.sync="itemDetailDialog"
      @click="closeItemDetailDialog">
      <div class="item-detail">
        <div class="field-box"><span class="field-title">Grade : </span><span class="field-value">{{ itemDetailInfo.sort
        }}</span></div>
        <div class="field-box"><span class="field-title">PN : </span><span class="field-value">{{ itemDetailInfo.pn
        }}</span></div>
        <div class="field-box"><span class="field-title">Replace PN : </span><span class="field-value">{{
          itemDetailInfo.replacePn
        }}</span></div>
        <div class="field-box"><span class="field-title">Part Name : </span><span class="field-value">{{
          itemDetailInfo.name
        }}</span></div>
        <div v-if="userLevel == 3" class="field-box"><span class="field-title">Price : </span><span
            class="field-value">{{
              itemDetailInfo.price }}</span></div>
        <div class="field-box"><span class="field-title">Remark : </span><span class="field-value">{{
          itemDetailInfo.remark
        }}</span></div>
        <div class="field-box"><span class="field-title">Unit Qty : </span><span class="field-value">{{
          itemDetailInfo.unitqty
        }}</span></div>
        <div class="field-box"><span class="field-title">HAND : </span><span class="field-value">{{ itemDetailInfo.hand
        }}</span></div>
        <div class="field-box"><span class="field-title">Interchange TYPE : </span><span class="field-value">{{
          itemDetailInfo.interchangetype
        }}</span></div>
        <div class="field-box"><span class="field-title">Lou's Interchange TYPE : </span><span class="field-value">{{
          itemDetailInfo.lousinterchangetype
        }}</span></div>
        <div class="field-box"><span class="field-title">Replace Luo NO : </span><span class="field-value">{{
          itemDetailInfo.replaceluono
        }}</span></div>
        <div v-if="itemDetailInfo.imageList" class="item-images">
          <div v-for="(item, index) in itemDetailInfo.imageList" :key="index" class="item-image"><img
              @click="onItemPreview" :src="item.url"></div>
          <el-image-viewer style="z-index:2010 !important;" v-if="showItemViewer" :on-close="closeItemViewer"
            :url-list=itemPriviewImgList></el-image-viewer>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>
    <!------------------- item-detail end ----------------->
    <!------------------- change password start --------------->
    <el-dialog title="Modify Password" :visible.sync="changePwdDialog" width="30%" @click="closePwdDialog">
      <el-form label-width="180px" :model="changePwdForm" :rules="pwdRules" ref="changePwdForm">
        <el-form-item label="Email">
          <el-input size="small" disabled style="width:80%" v-model="changePwdForm.email" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="Old password" prop="old">
          <el-input type="password" size="small" style="width:80%" v-model="changePwdForm.old" class="form-input">
          </el-input>
        </el-form-item>
        <el-form-item label="New Password" prop="password">
          <el-input type="password" size="small" style="width:80%" v-model="changePwdForm.password" class="form-input">
          </el-input>
        </el-form-item>
        <el-form-item label="New Password Again" prop="password2">
          <el-input type="password" size="small" style="width:80%" v-model="changePwdForm.password2" class="form-input">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submitPwdForm('changePwdForm')">Submit</el-button>
          <el-button size="small" @click="closePwdDialog">Cancel</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>
    <!------------------- change password end ----------------->

    <!------------------- add cart start --------------->
    <el-dialog title="Add Cart" :visible.sync="cartDetailDialog" width="40%" @click="closeCartDialog">
      <el-form label-width="180px" :model="cartForm">
        <el-form-item label="Car" v-if="cartForm.carName">
          <el-input type="text" size="small" disabled style="width:80%" v-model="cartForm.carName" class="form-input">
          </el-input>
        </el-form-item>
        <el-form-item label="Part Name">
          <el-input type="text" size="small" disabled style="width:80%" v-model="cartForm.treeName" class="form-input">
          </el-input>
        </el-form-item>
        <el-form-item label="PN">
          <el-input type="text" size="small" disabled style="width:80%" v-model="cartForm.itemPn" class="form-input">
          </el-input>
        </el-form-item>
        <el-form-item label="Name">
          <el-input type="text" size="small" disabled style="width:80%" v-model="cartForm.itemName" class="form-input">
          </el-input>
        </el-form-item>
        <el-form-item label="Quantity">
          <el-input-number size="small" v-model="cartForm.count" :min="1" :max="999999">
          </el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submitCartForm()">Confirm Add</el-button>
          <!-- <el-button size="small" @click="closeCartDialog">Cancel</el-button> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>
    <!------------------- add cart end ----------------->

    <!------------------- cart list start --------------->
    <el-dialog title="Order Info" :visible.sync="cartListDialog" width="70%" top="8vh" center
      @click="closeCartListDialog">
      <div class="nav-title"><span>Item List</span></div>
      <el-table size="medium" :data="cartList" highlight-current-row border stripe element-loading-text="拼命加载中"
        style="width: 100%;">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="carName" label="Car" min-width="100"></el-table-column>
        <el-table-column prop="treeName" label="Part Name" min-width="100"></el-table-column>
        <el-table-column prop="itemPn" label="PN" min-width="100"></el-table-column>
        <el-table-column prop="itemName" label="Name" min-width="100"></el-table-column>
        <el-table-column prop="count" label="Counts" align="center" min-width="140">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.count" @change="changeCartCount(scope.row)" :min="1" :max="9999">
            </el-input-number>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Operation" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteCart(scope.$index, scope.row.id)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="nav-title"><span>Form Data</span></div>
      <el-form label-width="180px" :model="orderForm" :rules="orderRules" ref="orderForm"
        style="width:80%;margin:10px auto;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="Name" prop="name">
              <el-input type="text" size="small" v-model="orderForm.name" class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mobile" prop="mobile">
              <el-input type="text" size="small" v-model="orderForm.mobile" class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Company">
              <el-input type="text" size="small" v-model="orderForm.company" class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Country" prop="country">
              <el-input type="text" size="small" v-model="orderForm.country" class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Email" prop="email">
              <el-input type="text" size="small" v-model="orderForm.email" class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Address">
              <el-input type="text" size="small" v-model="orderForm.address" class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Remark">
          <el-input type="textarea" size="small" v-model="orderForm.remark" class="form-input">
          </el-input>
        </el-form-item>

      </el-form>
      <div class="cart-btn">
        <el-button size="small" type="primary" @click="submitOrder('orderForm')">Submit Orders</el-button>
        <el-button size="small" @click="closeCartListDialog">Cancel</el-button>
      </div>

    </el-dialog>
    <!------------------- cart list end ----------------->

    <!------------------- order detail start --------------->
    <el-dialog title="Order Detail" :visible.sync="orderDetailDialog" width="70%" top="8vh"
      @click="closeOrderDetailDialog">
      <div class="order-details">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content">
              <span class="title">CreateTime:</span>
              <span class="value">{{ orderDetailInfo.order.createDate | timestampToTime }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <span class="title">Order NO:</span>
              <span class="value">{{ orderDetailInfo.order.orderNum }}</span>
            </div>
          </el-col>
          <el-col :span="12" v-if="orderDetailInfo.order.reply">
            <div class="grid-content">
              <span class="title">Reply Content:</span>
              <span class="value">{{ orderDetailInfo.order.reply }}</span>
            </div>
          </el-col>
          <el-col :span="12" v-if="orderDetailInfo.order.state == 3 && orderDetailInfo.order.priceUrl">
            <div class="grid-content">
              <span class="title">Price Info:</span>
              <span class="value">
                <el-button size="small" plain type="primary" @click="downPrice(orderDetailInfo.order.priceUrl)">
                  Download<i class="el-icon-download el-icon--right"></i></el-button>
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table size="medium" :data="orderDetailInfo.itemList" highlight-current-row stripe style="width: 100%;">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="carName" label="Car" min-width="100"></el-table-column>
        <el-table-column prop="treeName" label="Part Name" min-width="100"></el-table-column>
        <el-table-column prop="itemPn" label="PN" min-width="100"></el-table-column>
        <el-table-column prop="itemName" label="Name" min-width="100"></el-table-column>
        <el-table-column prop="count" label="Count" min-width="100"></el-table-column>
      </el-table>
    </el-dialog>
    <!------------------- order detail end ----------------->

    <!------------------- leaveword start --------------->
    <el-dialog title="Leave Message" :visible.sync="messageDialog" width="50%" @click="closeMessageDialog">
      <el-form label-width="180px" :model="messageForm" :rules="messageRules" ref="messageForm">
        <el-form-item label="Name" prop="name">
          <el-input size="small" style="width:80%" v-model="messageForm.name" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input size="small" style="width:80%" v-model="messageForm.email" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="Mobile">
          <el-input size="small" style="width:80%" v-model="messageForm.mobile" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="Country">
          <el-input size="small" style="width:80%" v-model="messageForm.country" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="Message" prop="message">
          <el-input type="textarea" size="small" style="width:80%" v-model="messageForm.message" class="form-input">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="submitMessageForm('messageForm')">Submit</el-button>
          <el-button size="small" @click="closeMessageDialog">Cancel</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>
    <!------------------- leaveword end ----------------->
  </div>
</template>

<script>
import {
  user_refresh_token, tree_page, item_page, tree_level_all, user_change_pwd,
  web_config_by_id, web_item_by_id, web_navs_by_id, web_search_items, web_tree_by_id,
  web_current_user, item_detail, add_cart, update_cart, query_cart, cart_list,
  submit_order, order_list, cart_del, itemName_list, order_cancel, order_detail, video_list, leave_add
} from "../../api/api";
import './../../assets/css/Home.css';
import './../../assets/css/tree.css';
import ctree from "../../components/ctree";
import Pagination from "../../components/Pagination";
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
  data() {
    return {
      //-------------------------------common--------------------
      timer: null, // 定时器
      // 当前用户信息
      currentUser: {},

      // 当前选中的元素
      currentNode: null,

      // trees-子栏目列表 
      // bgContent-空白背景 
      // treeDetail-子栏目详情  
      // searchItems-配件搜索列表  触发事件:1.搜索  2.点击节点 
      // myorders  订单列表
      // itemNames 名称列表
      // videos 视频列表
      currentContentPanel: 'bgContent',
      treeNavs: [], // 当前栏目及其所有的父节点列表 面包屑使用
      showTreeViewer: false, // 栏目图片预览
      showItemViewer: false, // 栏目图片预览

      //-------------------------------head & foot--------------------
      userLevel: 1,
      personShow: false,

      changePwdDialog: false,
      changePwdForm: {
        email: '',
        old: '',
        password: '',
        password2: '',
        appFlag: 1
      },
      pwdRules: {
        old: [{ required: true, message: "please type old password", trigger: "blur" }],
        password: [{ required: true, message: "please type new password", trigger: "blur" }],
        password2: [{ required: true, message: "please type new password again", trigger: "blur" }]
      },
      footData: {
        mobile: '',
        email: '',
        address: ''
      },

      //-------------------------------tree--------------------
      // 树层级列表
      treeLevelList: [],

      // 分页表单
      treePageParams: {
        currentPage: 1,
        pageSize: 200,
        total: 0
      },
      treeChildList: [],
      //-------------------------------item--------------------
      // 搜索表单
      itemSearchForm: {
        pn: '',
        name: ''
      },
      nameList: [],
      videoList: [],
      // 分页表单
      itemPageParams: {
        currentPage: 1,
        pageSize: 200,
        total: 0
      },
      itemList: [],
      itemSearchList: [],
      itemDetailDialog: false,
      itemDetailInfo: {
        sort: null,
        itemPn: '',
        itemName: '',
        replacePn: '',
        name: '',
        price: '',
        remark: '',
        image: '',
        imageList: []
      },
      itemPriviewImgList: [],

      //-----------------------------add cart--------------------
      cartDetailDialog: false,
      orderDetailDialog: false,
      cartForm: {
        id: '',
        carId: '',
        carName: '',
        treeId: '',
        treeName: '',
        itemPn: '',
        itemName: '',
        itemId: '',
        count: 1,
        appFlag: 1
      },
      cartList: [],
      cartListDialog: false,
      multipleSelection: [],
      orderList: [],
      orderForm: {
        name: '',
        mobile: '',
        email: '',
        company: '',
        address: '',
        country: '',
        remark: ''
      },
      orderRules: {
        name: [{ required: true, message: "Please type name", trigger: "blur" }],
        mobile: [{ required: true, message: "Please type mobile", trigger: "blur" }],
        country: [{ required: true, message: "Please type country", trigger: "blur" }],
        email: [{ required: true, message: "Please type email", trigger: "blur" }],
      },
      cartCount: 0,
      orderDetailInfo: {
        itemList: [],
        order: {
          id: '',
          createDate: '',
          state: '',
          orderNum: '',
          priceUrl: ''
        }
      },
      //--------------------留言功能---------------
      messageDialog: false,
      messageForm: {
        name: '',
        country: '',
        email: '',
        mobile: '',
        message: '',
      },
      messageRules: {
        name: [{ required: true, message: "please type name", trigger: "blur" }],
        email: [{ required: true, message: "please type email", trigger: "blur" }],
        message: [{ required: true, message: "please type message", trigger: "blur" }]
      },
      //-------------------视频播放
      videoPlayDialog: false

    };
  },

  // 注册组件
  // components: {ctree,Pagination,ElImageViewer},
  components: { ctree, Pagination },

  mounted() {
    this.dragControllerDiv();

    document.oncontextmenu = function () {
      return false;
    };
  },
  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    // 获取用户级别
    this.userLevel = window.localStorage.getItem('app_userLevel');
    // 获取所有树列表
    this.getTreeList();
    // 获取底部配置信息
    this.getConfigInfo();
    this.getNameList();
    this.getVideoList(12);
    // 查询购物车数量
    this.getCartCount();

    this.orderForm.mobile = window.localStorage.getItem('mobile');
    this.orderForm.company = window.localStorage.getItem('company');
    this.orderForm.country = window.localStorage.getItem('country');
    this.orderForm.email = window.localStorage.getItem('email');

  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken()
        }, 10 * 60 * 1000)
      }
    },
    async getNameList() {
      const nameList = await itemName_list({ appFlag: 1, flag: 1, size: 100 });
      this.nameList = nameList.data;
    },
    async getVideoList(size) {
      const videoData = await video_list({ appFlag: 1, size: size });
      this.videoList = videoData.data;
      if (this.videoList) {
        for (var i = 0; i < this.videoList.length; i++) {
          this.videoList[i].videoUrl = JSON.parse(this.videoList[i].video).url;
        }
      }
    },
    async refreshToken() {
      let param = { "page": "website", "appFlag": 1, "token": window.localStorage.getItem("app_user_token") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("app_user_token", data.data);
    },

    //***********************header start************************ */
    // 个人中心显隐
    toggle() {
      if (this.personShow) {
        this.personShow = false;
      } else {
        this.personShow = true;
      }
    },
    // 修改密码
    showChangePwdDialog() {
      this.personShow = false;
      this.changePwdDialog = true;
      this.getCurrentUser();
    },
    async getCurrentUser() {
      let param = { appFlag: 1 }
      const user = await web_current_user(param);
      this.changePwdForm.email = user.data.email;
    },
    closePwdDialog() {
      this.changePwdDialog = false;
    },
    submitPwdForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          user_change_pwd(this.changePwdForm).then(res => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "operate success!"
              });
              this.changePwdForm.email = '';
              this.changePwdForm.old = '';
              this.changePwdForm.password = '';
              this.changePwdForm.password2 = '';
              this.changePwdDialog = false;
            } else {
              this.$message({
                type: "error",
                message: res.message
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    // 退出登录
    logout() {
      this.personShow = false;
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            window.localStorage.removeItem("app_user_token");
            window.location.href = "https://epc.yiec.com/";   // TODO
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 300)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    async getConfigInfo() {
      let param = { "id": 1, "appFlag": 1 };
      const data = await web_config_by_id(param);
      this.footData = data.data;
      console.log(this.footData)
    },
    //***********************header end************************ */

    //***********************tree start************************ */
    clickMg() {
      let node = { "id": 1, "text": "MG", "pid": 0, "leaf": 0, "showFlag": 1 };
      this.clickNode(node);
    },
    clickMauxs() {
      let node = { "id": 2, "text": "MAXUS", "pid": 0, "leaf": 0, "showFlag": 1 };
      this.clickNode(node);
    },
    clickWuling() {
      let node = { "id": 30000, "text": "WULING", "pid": 0, "leaf": 0, "showFlag": 1 };
      this.clickNode(node);
    },
    clickChery() {
      let node = { "id": 40, "text": "CHERY", "pid": 0, "leaf": 0, "showFlag": 1 };
      this.clickNode(node);
    },
    clickIVECO() {
      let node = { "id": 41, "text": "IVECO", "pid": 0, "leaf": 0, "showFlag": 1 };
      this.clickNode(node);
    },
    clickROEWE() {
      let node = { "id": 100000, "text": "ROEWE", "pid": 0, "leaf": 0, "showFlag": 1 };
      this.clickNode(node);
    },
    clickJETOUR() {
      let node = { "id": 100200, "text": "ROEWE", "pid": 0, "leaf": 0, "showFlag": 1 };
      this.clickNode(node);
    },
    // 点击树节点,获取当前节点及其子列表
    clickNode(target) {
      // 清空之前的数据
      this.itemList = [];
      this.treeChildList = [];

      // 当前节点
      this.currentNode = target;
      // 查询面包屑列表
      this.getTreeNavs(this.currentNode.id);
      // 叶子节点 -> 查询配件列表
      if (this.currentNode.leaf == 1) {
        this.get_item_page(this.itemPageParams.currentPage, this.treePageParams.pageSize);
        this.currentContentPanel = "treeDetail";
      }
      // 非叶子节点 -> 查询子栏目
      else {
        this.get_tree_page(this.treePageParams.currentPage, this.treePageParams.pageSize);
        this.currentContentPanel = "trees";
      }
    },
    // 点击搜索列表的节点
    async clickSearchNode(treeId) {
      let param = { "id": treeId, "appFlag": 1 };
      const data = await web_tree_by_id(param);
      this.clickNode(data.data);
    },
    // 获取所有栏目树列表
    async getTreeList() {
      let param = {};
      param.appFlag = 1;
      param.showFlag = 1;
      const data = await tree_level_all(param);
      this.treeLevelList = data.data;
    },
    // 查询面包屑猎豹
    async getTreeNavs(currentId) {
      const param = {};
      param.id = currentId;
      param.appFlag = 1;
      const data = await web_navs_by_id(param);
      this.treeNavs = data.data;

      this.$refs.ctree.initData(true, true, true, this.treeNavs.map(item => item.id));
    },

    // 子栏目分页
    async get_tree_page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;
      if (this.currentNode.leaf == 1) {
        param.pid = this.currentNode.pid;
      } else {
        param.pid = this.currentNode.id;
      }
      param.appFlag = 1;
      param.showFlag = 1;

      const data = await tree_page(param);

      this.treePageParams.total = data.data.total;
      this.treePageParams.pageSize = data.data.pageSize;
      this.treePageParams.currentPage = data.data.currentPage;

      this.treeChildList = data.data.list;
    },
    // 图片预览
    onTreePreview() {
      this.showTreeViewer = true
    },
    closeTreeViewer() {
      this.showTreeViewer = false
    },
    //***********************tree end************************ */

    //***********************item start************************ */
    // 配件分页
    async get_item_page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;

      param.treeId = this.currentNode.id;
      param.appFlag = 1;

      const data = await item_page(param);

      this.itemPageParams.total = data.data.total;
      this.itemPageParams.pageSize = data.data.pageSize;
      this.itemPageParams.currentPage = data.data.currentPage;
      this.itemList = data.data.list;
    },
    // 搜索件号
    searchItem() {
      const param = {};
      param.pn = this.itemSearchForm.pn;
      param.name = this.itemSearchForm.name;
      param.appFlag = 1;
      this.search_item_list(param);
    },
    searchByItemName(name) {
      const param = {};
      param.name = name;
      param.appFlag = 1;
      this.search_item_list(param);
    },
    // 配件分页
    async search_item_list(params) {
      // 查询
      await web_search_items(params).then(res => {
        if (res.code == 1) {
          this.itemSearchList = res.data;
          if (this.itemSearchList && this.itemSearchList.length > 100) {
            this.itemSearchList = this.itemSearchList.splice(0, 100);
          }
          this.currentContentPanel = 'searchItems';
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });

    },
    // 重置搜索表单
    reset() {
      this.itemSearchForm.pn = '';
      this.itemSearchForm.name = ''
    },

    // 查看配件详情
    showItemDetail(item) {
      this.itemDetailDialog = true;
      this.getItemById(item.id);
    },
    async getItemById(itemId) {
      const param = {};
      param.id = itemId;
      param.appFlag = 1;

      const data = await web_item_by_id(param);
      this.itemDetailInfo = data.data;
      if (this.itemDetailInfo.image != null && this.itemDetailInfo.image != undefined && this.itemDetailInfo.image != '') {
        this.itemDetailInfo.imageList = JSON.parse(this.itemDetailInfo.image);
        // 预览图片处理
        if (this.itemDetailInfo.imageList != null && this.itemDetailInfo.imageList.length > 0) {
          var imgList = []
          this.itemDetailInfo.imageList.forEach(function (item) {
            imgList.push(item.url);
          })
          console.log(imgList)
          this.itemPriviewImgList = imgList;
        }
      }
    },

    closeItemDetailDialog() {
      this.itemDetailDialog = false;
      this.itemDetailInfo = {};

    },
    // 图片预览
    onItemPreview() {
      this.showItemViewer = true;
    },
    closeItemViewer() {
      this.showItemViewer = false
    },
    //***********************item end************************ */

    //***********************添加购物车 start************************ */
    openCart(row) {
      this.getItemDetail(row.id);
    },

    async getItemDetail(itemId) {
      const param = {};
      param.itemId = itemId;
      param.appFlag = 1;

      const dataOld = await query_cart(param);
      // 查询之前该配件是否已经添加到购物车了
      // 是-修改
      if (dataOld && dataOld.code == 1 && dataOld.data) {
        this.cartForm.carId = dataOld.data.carId;
        this.cartForm.carName = dataOld.data.carName;
        this.cartForm.treeId = dataOld.data.treeId;
        this.cartForm.treeName = dataOld.data.treeName;
        this.cartForm.itemPn = dataOld.data.itemPn;
        this.cartForm.itemName = dataOld.data.itemName;
        this.cartForm.itemId = dataOld.data.itemId;
        this.cartForm.id = dataOld.data.id;
        this.cartForm.count = dataOld.data.count;
        this.cartForm.appFlag = 1;
      }
      // 否-新增
      else {
        const data = await item_detail(param);
        let car = data.data.car;
        let tree = data.data.tree;
        let item = data.data.item;
        if (car) {
          this.cartForm.carId = car.id;
          this.cartForm.carName = car.name;
        }
        this.cartForm.treeId = tree.id;
        this.cartForm.treeName = tree.name;
        this.cartForm.itemPn = item.pn;
        this.cartForm.itemName = item.name;
        this.cartForm.itemId = item.id;
        this.cartForm.count = 1;  // 初始化数量
        this.cartForm.appFlag = 1;
        this.cartForm.id = null;
      }
      this.addCartDialog();
    },
    addCartDialog() {
      this.cartDetailDialog = true;
    },
    closeCartDialog() {
      this.cartDetailDialog = false;

    },
    closeCartListDialog() {
      this.cartListDialog = false;
    },
    closeOrderDetailDialog() {
      this.orderDetailDialog = false;
    },

    submitCartForm() {
      if (!this.cartForm.itemId || !this.cartForm.treeId) {
        this.$message({
          message: "System error Please try again!",
          type: "error"
        });
      } else {
        if (!this.cartForm.id) {
          this.addCart(this.cartForm);
        } else {
          this.updateCart(this.cartForm);
        }

      }
    },
    // 新增
    async addCart(formData) {
      await add_cart(formData).then(res => {
        if (res.code == 1) {
          this.$message({
            message: "Success!",
            type: "success"
          });
          this.getCartCount();
          this.closeCartDialog();
        } else {
          this.$message({
            message: "System error Please try again!",
            type: "error"
          });
        }
      });
    },
    // 修改
    async updateCart(formData) {
      await update_cart(formData).then(res => {
        if (res.code == 1) {
          this.$message({
            message: "Success!",
            type: "success"
          });
          this.closeCartDialog();
        } else {
          this.$message({
            message: "System error Please try again!",
            type: "error"
          });
        }
      });
    },
    // 购物车列表
    async getCartList() {
      const param = { appFlag: 1 };
      await cart_list(param).then(res => {
        if (res.code == 1) {
          this.cartList = res.data;
          this.cartListDialog = true;
        } else {
          this.$message({
            message: "System error Please try again!",
            type: "error"
          });
        }
      });
    },
    async getCartCount() {
      const param = { appFlag: 1 };
      await cart_list(param).then(res => {
        if (res.code == 1) {
          this.cartCount = res.data.length
        } else {
          this.$message({
            message: "System error Please try again!",
            type: "error"
          });
        }
      });
    },
    deleteCart(index, id) {
      this.$confirm("Will be permanently deleted,Continue?", "Tip", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        let param = { appFlag: 1, id: id }
        cart_del(param).then(res => {
          if (res.code === 1) {
            this.cartList.splice(index, 1);
            this.getCartCount();
            this.$message({
              type: "success",
              message: "Success!"
            });
          } else {
            this.$message({
              message: "System error Please try again!",
              type: "error"
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "Has been cancelled!"
        });
      });
    },
    async changeCartCount(row) {
      let param = { id: row.id, count: row.count, appFlag: 1 }
      await update_cart(param);
    },

    submitOrder(orderData) {
      this.$refs[orderData].validate(valid => {
        if (valid) {
          let ids = this.cartList.map(it => it.id).join(",")
          if (!ids) {
            this.$message({
              message: "No Cart items",
              type: "error"
            });
            return
          }
          this.orderForm.appFlag = 1;
          this.orderForm.cartIds = ids;
          this.submitOrder_(this.orderForm);
        }

      });

    },
    cancelOrder(id) {
      this.$confirm("Will be permanently deleted,Continue?", "Tip", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        let param = { appFlag: 1, id: id }
        order_cancel(param).then(res => {
          if (res.code == 1) {
            this.$message({
              message: "Success!",
              type: "success"
            });
            this.myOrders()
          } else {
            this.$message({
              message: "System error Please try again!",
              type: "error"
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: "info",
          message: "Has been cancelled!"
        });
      });
    },
    async submitOrder_(orderData) {
      await submit_order(orderData).then(res => {
        if (res.code == 1) {
          this.$message({
            message: "Success!",
            type: "success"
          });
          this.getCartCount();
          this.cartListDialog = false;
          this.multipleSelection = [];
        } else {
          this.$message({
            message: "System error Please try again!",
            type: "error"
          });
        }
      });
    },

    async myOrders() {
      this.personShow = false;
      let params = { appFlag: 1 }
      await order_list(params).then(res => {
        if (res.code == 1) {
          this.orderList = res.data;
          this.currentContentPanel = 'myorders';
        } else {
          this.$message({
            message: "System error Please try again!",
            type: "error"
          });
        }
      });
    },
    async orderDetail(orderId) {
      this.orderDetailDialog = true;
      let param = { appFlag: 1, id: orderId }
      await order_detail(param).then(res => {
        if (res.code == 1) {
          this.orderDetailInfo = res.data;
        } else {
          this.$message({
            message: "System error Please try again!",
            type: "error"
          });
        }
      })
    },
    downPrice(url) {
      window.location.href = url
    },

    //***********************添加购物车 end************************ */
    //***********************留言 start************************ */
    leaveMessage() {
      this.personShow = false;
      this.messageDialog = true;
      this.messageForm.mobile = window.localStorage.getItem('mobile');
      this.messageForm.country = window.localStorage.getItem('country');
      this.messageForm.email = window.localStorage.getItem('email');
    },
    closeMessageDialog() {
      this.messageDialog = false;
    },
    submitMessageForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          leave_add(this.messageForm).then(res => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "operate success!"
              });
              this.messageForm.message = '';
              this.messageDialog = false;
            } else {
              this.$message({
                type: "error",
                message: res.message
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //***********************留言 end************************ */

    //***********************视频播放 start************************ */
    openVideo(url) {
      this.videoPlayDialog = true;
      this.$refs.videoRef.src = url;
      this.$refs.videoRef.load();

    },
    closeVideo() {
      this.videoPlayDialog = false;
      this.$refs.videoRef.pause();//暂停

    },
    itemNameMore() {
      this.currentContentPanel = 'itemNames';
      this.getNameList();

    },
    videoMore() {
      this.currentContentPanel = 'videos';
      this.getVideoList(999);
    },
    //***********************视频播放 end************************ */


    // // 禁止鼠标右击
    // show (event) {
    //     // 此处可以使用判断条件控制是否需要阻止右键
    //     alert();
    //     event.preventDefault(); 
    // },


    dragControllerDiv: function () {
      var resize = document.getElementsByClassName('resize');
      var left = document.getElementsByClassName('left-box');
      var mid = document.getElementsByClassName('right-box');
      var box = document.getElementsByClassName('content');
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          //颜色改变提醒
          resize[i].style.background = '#818181';
          var startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

            if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
            if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

            resize[i].style.left = moveLen; // 设置左侧区域的宽度

            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + 'px';
              mid[j].style.width = (box[i].clientWidth - moveLen - 10) + 'px';
            }
          };
          // 鼠标松开事件
          document.onmouseup = function (evt) {
            //颜色恢复
            resize[i].style.background = '#d6d6d6';
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    },


  }
};
</script>



// WEBPACK FOOTER //
// src/views/website/Home.vue